module.exports = __webpack_public_path__ + "static/media/Sorghum8-10.bb65c0c9.PNG";